import {tDouble} from "../../../../shared/utils/translateFunc";

export const data = {
  title: 'Create new company',
  subtitle: tDouble("crete_comp_text")
}